import React from 'react';
import { Link } from 'react-router-dom';

import './Group.scss';

import { mapGroupRoles } from '@helpers';

const Group = ({ group }) => {
  return (
    <div className="sb-row-item">
      <div className="sb-row--group-name">
        <p>
          <Link to={`/dashboard/groups/${group.id}`}>
            <b>{group.name}</b>
          </Link>
        </p>
      </div>
      <div className="sb-row--group-email">
        <p>{mapGroupRoles(group.roles)[0]}</p>
      </div>
      <div className="sb-row--group-id">
        <p>ID: {group.id}</p>
      </div>
    </div>
  );
};

export default Group;
